<template>
  <div style="background-color: white">
    <el-row style="padding-top: 10px">
      <el-col :span="24">
        <el-form
          :inline="true"
          ref="deviceInfo"
          :model="deviceInfo"
          class="demo-form-inline"
          style="float: right !important"
        >
          <el-form-item :label="lable.ywmc">
            <el-select
              v-model="deviceInfo.state"
              filterable
              clearable
              placeholder="全部类型"
              style="width: 120px"
            >
              <el-option
                v-for="item in statues"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期">
            <el-date-picker
              v-model="deviceInfo.date"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="screen"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table
          :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
          :cell-style="{ textAlign: 'center' }"
          :data="deviceData"
          tooltip-effect="dark"
          style="width: 100%; text-align: center"
          stripe
        >
          <el-table-column
            :label="lable.index"
            type="index"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="ywmc"
            sortable
            :label="lable.ywmc"
            width="120PX"
          >
          </el-table-column>
          <el-table-column
            prop="ywdh"
            :label="lable.ywdh"
            show-overflow-tooltip
          >
            <template slot-scope="scope" show-overflow-tooltip>
              <el-link
                :underline="false"
                @click="biu(scope.row)"
                style="color: #4095e5; text-decoration: none"
              >
                {{ scope.row.ywdh }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="ssdw"
            :label="lable.ssdw"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="sbmc"
            :label="lable.sbmc"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="sqsj"
            sortable
            :label="lable.sqsj"
            :formatter="formateTime"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="ywzt"
            :label="lable.statue"
            show-overflow-tooltip
          >
            <template slot-scope="scope" show-overflow-tooltip>
              <span style="color: #cc3300" v-text="scope.row.ywzt"></span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top: 5px; height: 35px">
        <el-pagination
          v-if="deviceData.length > 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { myTranslate, findByModule } from "../../api/api";
export default {
  data() {
    return {
      deviceInfo: {
        date: "",
        content: "",
        state: "",
      },
      lable: {},
      statues: [
        { label: "设备检定", value: "设备检定" },
        { label: "维保审核", value: "维保审核" },
        { label: "报废审核", value: "报废审核" },
        { label: "报废确认", value: "报废确认" },
        { label: "调拨审核", value: "调拨审核" },
        { label: "调出确认", value: "调出确认" },
        { label: "调入确认", value: "调入确认" },
        { label: "任务执行", value: "任务执行" },
        { label: "待维保", value: "待维保" },
        { label: "维保确认", value: "维保确认" },
        { label: "设备校准", value: "设备校准" },
        { label: "调拨驳回", value: "调拨驳回" },
        { label: "报废驳回", value: "报废驳回" },
        { label: "维保驳回", value: "维保驳回" },
        { label: "采购驳回", value: "采购驳回" },
        { label: "采购审核", value: "采购审核" },
        { label: "设备审核", value: "设备审核" },
        { label: "设备借用审核", value: "设备借用审核" },
        { label: "设备领用确认", value: "设备领用确认" },
      ],
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      data: [],
      deviceData: [],
    };
  },
  methods: {
    biu(row) {
      // sessionStorage.setItem("rwID", row.yedh); //添加路由跳转至查看设备
      var key = row.ywdh.substring(0, 2);
      if (key == "JD" || key == "jd") {
        sessionStorage.setItem("jdid", row.ywdh);

        let val = {
          path: "/submit",
          name: "设备检定-确认",
        }; // debugger //保存数据
        this.$router.push({
          path: "submit",
        });
        this.$store.commit("pushtags", val);
      }
      if (key == "SH" || key == "sh") {
        let val = {
          path: "/Examine_shebeik",
          name: "设备审核",
        }; // debugger //保存数据
        this.$router.push({
          path: "Examine_shebeik",
        });
        this.$store.commit("pushtags", val);
      }
      if (key == "rw" || key == "RW") {
        if (row.statue == 0) {
          let val = {
            path: "/taskExecution",
            name: "任务执行 ",
          }; // debugger //保存数据
          this.$router.push({
            path: "taskExecution",
          });
          this.$store.commit("pushtags", val);
        }
        if (row.statue == 1) {
          let val = {
            path: "/complete",
            name: "任务完成",
          }; // debugger //保存数据
          this.$router.push({
            path: "complete",
          });
          this.$store.commit("pushtags", val);
        }
        if (row.statue == 2) {
          let val = {
            path: "/taskEvaluate",
            name: "任务评价",
          }; // debugger //保存数据
          this.$router.push({
            path: "taskEvaluate",
          });
          this.$store.commit("pushtags", val);
        }
      }
      if (key == "BF" || key == "bf") {
        if (row.statue == 1) {
          let val2 = {
            path: "/examine",
            name: "报废审核",
          }; // debugger //保存数据
          this.$router.push({
            path: "examine",
          });
          this.$store.commit("pushtags", val2);
        }
        if (row.statue == 0) {
          let val2 = {
            path: "/scrap",
            name: "报废列表",
          }; // debugger //保存数据
          this.$router.push({
            path: "confirmation",
          });
          this.$store.commit("pushtags", val2);
        }
        if (row.statue == 2) {
          let val2 = {
            path: "/confirmation",
            name: "报废确认",
          }; // debugger //保存数据
          this.$router.push({
            path: "confirmation",
          });
          this.$store.commit("pushtags", val2);
        }
      }
      if (key == "DB" || key == "db") {
        if (row.statue == 4) {
          let val3 = {
            path: "/transfer",
            name: "调拨审核",
          }; // debugger //保存数据
          this.$router.push({
            path: "transfer",
          });
          this.$store.commit("pushtags", val3);
        }
        if (row.statue == 0) {
          let val2 = {
            path: "/allocation",
            name: "调拨列表",
          }; // debugger //保存数据
          this.$router.push({
            path: "allocation",
          });
          this.$store.commit("pushtags", val2);
        }
        if (row.statue == 7) {
          let val3 = {
            path: "/confirmout",
            name: "调出确认",
          }; // debugger //保存数据
          this.$router.push({
            path: "confirmout",
          });
          this.$store.commit("pushtags", val3);
        }
        if (row.statue == 8) {
          let val3 = {
            path: "/confirmin",
            name: "调入确认",
          }; // debugger //保存数据
          this.$router.push({
            path: "confirmin",
          });
          this.$store.commit("pushtags", val3);
        }
        if (row.statue == 5) {
          let val3 = {
            path: "/select",
            name: "设备调拨",
          }; // debugger //保存数据
          this.$router.push({
            path: "allocation",
          });
          this.$store.commit("pushtags", val3);
        }
      }
      if (key == "WB" || key == "wb") {
        if (row.statue == 1) {
          let val = {
            path: "/audit",
            name: "维保审核",
          }; // debugger //保存数据
          this.$router.push({
            path: "audit",
          });
          this.$store.commit("pushtags", val);
        }
        if (row.statue == 0) {
          let val = {
            path: "/maintenance",
            name: "维保列表",
          }; // debugger //保存数据
          this.$router.push({
            path: "maintenance",
          });
          this.$store.commit("pushtags", val);
        }
        if (row.statue == 2) {
          let val = {
            path: "/input",
            name: "维保录入",
          }; // debugger //保存数据
          this.$router.push({
            path: "input",
          });
          this.$store.commit("pushtags", val);
        }
        if (row.statue == 3) {
          let val = {
            path: "/notarize",
            name: "维保确认",
          }; // debugger //保存数据
          this.$router.push({
            path: "notarize",
          });
          this.$store.commit("pushtags", val);
        }
      }
      if (key == "XZ" || key == "xz") {
        let val = {
          path: "/calibrationVerification",
          name: "校准信息",
        }; // debugger //保存数据
        sessionStorage.setItem("xzid", row.ywdh);

        this.$router.push({
          path: "calibrationSubmit",
        });
        this.$store.commit("pushtags", val);
      }
      if (key == "CG" || key == "cg") {
        let val = {
          path: "/purchase",
          name: "采购列表",
        }; // debugger //保存数据
        this.$router.push({
          path: "purchase",
        });
        this.$store.commit("pushtags", val);
      }

      if (key == "MK") {
        let val = {
          path: "/RecordConfirm",
          name: "设备借用审核",
        };
        this.$router.push({
          path: "RecordConfirm",
        });
        this.$store.commit("pushtags", val);
      }

      if (key == "MA") {
        let val = {
          path: "/MktRecord",
          name: "设备领用确认",
        };
        this.$router.push({
          path: "MktRecord",
        });
        this.$store.commit("pushtags", val);
      }
    },
    //筛选
    screen() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      var map = {
        userId: userinfo.userId,
      };
      myTranslate(map).then((datas) => {
        // debugger
        let { status, message, data } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error",
          });
        } else if (status == 200) {
          // this.data = data;
          this.data = data.sort((a, b) => {
            return Date.parse(b.sqsj) - Date.parse(a.sqsj);
          }); //降序
        } else {
          this.$message({
            message: "请求错误",
            type: "error",
          });
        }
      });
      var data =
        this.deviceInfo.date == null ? [null, null] : this.deviceInfo.date;
      var state = this.deviceInfo.state;
      var dataList = this.data;
      var start = data[0] != null ? Date.parse(data[0]) : 1;
      var end =
        data[1] != null ? Date.parse(data[1]) : 99999999999999999999999999999;
      let tableData = [];
      var i = 0;
      dataList.forEach((item) => {
        var sj = Date.parse(item.sqsj);
        i = i + 1;
        if (start < sj && sj < end) {
          if ((item.ywmc == state) | (state == "")) {
            tableData.push(item);
          }
        }
      });
      this.data = tableData;
      this.total = tableData.length;
      this.deviceData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    // 格式化时间显示到日期
    formateTime(row) {
      let nowData = new Date(row.sqsj);
      let year = nowData.getFullYear();
      let month = (nowData.getMonth() + 1).toString().padStart(2, "0");
      let date = nowData.getDate().toString().padStart(2, "0");
      return `${year}-${month}-${date}`;
    },
    //查找待办信息
    getDeviceinfo() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      var map = {
        userId: userinfo.userId,
      };
      myTranslate(map).then((datas) => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          if (data == null) {
            this.data = [];
          } else {
            this.data = data;
          }

          this.data = this.data.sort((a, b) => {
            return Date.parse(b.sqsj) - Date.parse(a.sqsj);
          }); //降序
          this.deviceData = this.data.slice(
            (this.pageIndex - 1) * this.pagesize,
            this.pageIndex * this.pagesize
          );
          this.total = data.length;
          // debugger
        }
      });
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
      //.slice()方法接受两个参数，开始和结束的值
      //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
      this.deviceData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.deviceData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    findLable() {
      findByModule("我的待办").then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.lable = data;
        }
      });
    },
  },
  created() {
    this.findLable();
    this.getDeviceinfo();
  },
};
</script>
<style>
.el-checkbox__inner {
  border: 1px solid #606266 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/needMe/MyNeeds.vue